import React                 from 'react';

import { v4 as uuidv4      } from 'uuid';

import { Typography        } from 'src/components/common/typography';
import { Area, 
         Box,
         Field, 
         Label,        
         TextareaVariants,        
         textarea_variants } from 'src/components/common/textarea/ui';



export interface Props extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  helperText?: string;
  error?: boolean | string;
  maxLength?: number;
  variant: TextareaVariants
}

export const Textarea: React.FC<Props> = ({
  label = 'Комментарий',
  placeholder = 'Введите комментарий',
  value,
  onChange,
  helperText,
  error = false,
  disabled,
  rows = 6,
  maxLength,
  id,
  variant = 'textarea_main',
  ...rest
}) => {
  const lookAndFeel = textarea_variants.get(variant)!;

  const _id = id || uuidv4();

  return (
    <Field lookAndFeel = { lookAndFeel }>
      <Label lookAndFeel = { lookAndFeel }>
        { label && <Typography variant='steelw400s12lh14'>{ label }</Typography> }
      </Label>

      <Box disabled={!!disabled} lookAndFeel = { lookAndFeel }>
        <Area
          id={_id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          disabled={disabled}
          {...rest}
          lookAndFeel = { lookAndFeel }
        />
      </Box>
    </Field>
  );
};
